"use client"

import dynamic from "next/dynamic"
import { useGenerateStudioFlag } from "@/features/generation"
import { GenerateImageContent } from "./generate-image-content"

// Only flagged users download the Studio bundle.
const GenerateStudioContent = dynamic(
  () => import("./generate-studio-content").then((mod) => mod.GenerateStudioContent),
  { ssr: false, loading: () => <div className="min-h-[calc(100dvh-9rem)] flex-1 bg-background" aria-busy="true" /> }
)

/** PostHog `generate-studio` picks the Studio layout; everyone else keeps the classic generator. */
export function GenerateImageGate() {
  const { enabled, loaded } = useGenerateStudioFlag()

  if (!loaded) {
    return <div className="min-h-[calc(100dvh-9rem)] flex-1 bg-background" aria-busy="true" />
  }
  return enabled ? <GenerateStudioContent /> : <GenerateImageContent />
}
